import { getCommonEnvVariables } from './getCommonEnvVariables';

export const ENV = getCommonEnvVariables();
